import type { VehiclePastAssociationDto } from '@cobliteam/api-lib/src/__generated__/graphql';
import Typography from '@cobliteam/ui/components/Typography';
import { format } from '@cobliteam/utils/date';
import AssociationDriverChange from './AssociationDriverChange';
import AssociationSourceText from './AssociationSourceText';

interface AssociationHistoryItemProps {
  association: VehiclePastAssociationDto & { previousDriver?: VehiclePastAssociationDto['driver'] };
}

const AssociationHistoryItem = ({ association }: AssociationHistoryItemProps) => {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex justify-between gap-4'>
        <AssociationSourceText association={association} />
        <Typography variant='text-md' color='secondary' className='whitespace-nowrap'>
          {format(association.associatedAt, "d MMM 'às' HH:mm")}
        </Typography>
      </div>
      <AssociationDriverChange previousDriver={association.previousDriver} currentDriver={association.driver} />
    </div>
  );
};

export default AssociationHistoryItem;
